import TeacherCommunicationSettings from './TeacherCommunicationSettings.page';

export default TeacherCommunicationSettings;